export default __webpack_public_path__ + "static/media/Notification.18308c92.svg";